import { useEffect } from 'react'

/**
 * Hold one cursor across the whole screen for the length of a gesture, and stop
 * the drag from selecting whatever it passes over.
 *
 * Both halves are needed for the same reason: pointer capture routes the
 * *events* to the handle, but the displayed cursor still follows whatever
 * element is under the pointer, and a drag that crosses text would otherwise
 * select it. Restores what was there before rather than clearing, so nested
 * gestures can't strip an outer one's cursor on the way out.
 *
 * Every drag surface in the panel wants exactly this — the three sidepanel
 * resize handles, the notepad's top edge, and the panel's own reposition drag —
 * so it lives here rather than being transcribed into each of them.
 */
export function useDragCursor(active: boolean, cursor: string) {
  useEffect(() => {
    if (!active) return
    const previousCursor = document.body.style.cursor
    const previousUserSelect = document.body.style.userSelect
    document.body.style.cursor = cursor
    document.body.style.userSelect = 'none'
    return () => {
      document.body.style.cursor = previousCursor
      document.body.style.userSelect = previousUserSelect
    }
  }, [active, cursor])
}
